import { css } from 'styled-components';

const panel = css`
  border-radius: ${(props) => props.theme.radius.panel};
  border: ${(props) => props.theme.borders.panel};
  padding: ${(props) => props.theme.paddings.panel};
`;

export { panel };
